import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditNoticeboardLayer from "../components/EditNoticeboardLayer";
 
 
const EditNoticeboardPage = () => {
  return (
    <>
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Noticeboard  </h5><Breadcrumb title="Edit Noticeboard" /></div>
 
        {/* CalendarMainLayer */}
        <EditNoticeboardLayer />
 
 
    </>
  );
};
 
export default EditNoticeboardPage;
 
 